import { Component } from '@angular/core';
import { membersuitesubledger_entry_itemsEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Subledger Entry Items') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitesubledger_entry_items-form',
    templateUrl: './membersuitesubledger_entry_items.form.component.html'
})
export class membersuitesubledger_entry_itemsFormComponent extends BaseFormComponent {
    public record!: membersuitesubledger_entry_itemsEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

